import { useMediaQuery, useTheme, Grid, ToggleButton } from '@mui/material';
import {
  CcfCalendarIcon,
  useTranslator,
  CcfScheduler,
  CcfButton,
  CcfUpArrowIcon,
  AgentScheduleForDisplay,
  CcfTypography,
  CcfOverflowIcon,
} from '@nice-ccf/ui-controls';
import { getApplicationLocale } from '@nice-ccf/ui-components';
import { useDispatch, useSelector } from 'react-redux';
import { fetchWemScheduleEvents } from './ccf-app-schedule.slice';
import { useEffect, useState, useRef } from 'react';
import FullCalendar from '@fullcalendar/react';
import ccfAppSchedulerStyles from './ccf-app-schedule.styles';
import dayjs from 'dayjs';
import 'dayjs/locale/en';
import 'dayjs/locale/he';
import 'dayjs/locale/pt-br';
//import { getWemScheduleChangeNotifications } from '../ccf-agent-notification/ccf-agent-notification.slice';
import {
  CcfAddEventPopover,
  useCcfCommitmentAddEventPopOverItems,
} from './ccf-add-event-popover';
//import { commitmentActions } from '../ccf-commitment/ccf-commitment.slice';
import { useCcfAppScheduleContent } from './ccf-app-schedule-content';
import { AgentSchedule } from '@nice-ccf/core-sdk';
//import { useCcfCommitmentList } from '../ccf-commitment/ccf-commitment-details';

/* eslint-disable-next-line */
export interface SchedulerLargeViewProps {
  isfullView?: boolean;
  isWemView?: boolean;
}

/**
 * Scheduler - returns app scheduler with both week and day view
 * @returns - SchedulerLargeView
 * @example - `<SchedulerLargeView />`
 */
const SchedulerLargeView = (props?: SchedulerLargeViewProps) => {
  const locale = useSelector(getApplicationLocale);
  const calendarComponentRef = useRef<InstanceType<typeof FullCalendar>>();
  const dispatch = useDispatch();
  const scheduleChangeNotifications = {};

  const [titleDate, setTitleDate] = useState<Date>();

  const theme = useTheme();
  const isSmView = useMediaQuery(theme.breakpoints.down('xl'));
  const [currentView, setCurrentView] = useState<string>(
    props?.isWemView ? 'week' : 'day'
  );
  const [isTodaySelected, setIstodaySelected] = useState<boolean>(false);
  const [translate] = useTranslator();
  const schedulerStyles = ccfAppSchedulerStyles(theme, isSmView);
  const popOverRef: React.RefObject<HTMLInputElement> = useRef(null);

  const { getCcfAppScheduleContent } = useCcfAppScheduleContent();
  const { disableAddEvent } = useCcfCommitmentAddEventPopOverItems();
  const todayDate = new Date();
  const commitments: AgentScheduleForDisplay[] = [
    {
      title: translate('shift'),
      backgroundColor: '#39c44a',
      start: new Date(),
      end: new Date(todayDate.setHours(todayDate.getHours() + 5)),
      id: '1',
      notes: 'My test meeting',
      description: 'Test1',
      isWEMEvent: false,
    },
    {
      title: translate('Meeting'),
      backgroundColor: '#007CBE',
      start: new Date(todayDate.setHours(todayDate.getHours() - 2)),
      end: new Date(todayDate.setHours(todayDate.getHours() + 1)),
      id: '2',
      notes: 'My test meeting',
      description: 'Test2',
      isWEMEvent: false,
    },
    {
      title: translate('Break'),
      backgroundColor: '#926097',
      start: new Date(todayDate.setHours(todayDate.getHours() + 1)),
      end: new Date(todayDate.setHours(todayDate.getHours() + 1)),
      id: '3',
      notes: 'My test meeting',
      description: 'Test3',
      isWEMEvent: false,
    },
  ];
  const events: AgentSchedule[] = [
    {
      title: 'Test4',
      backgroundColor: '#007CBE',
      start: new Date('24/3/2023'),
      end: new Date('23/4/2023'),
      id: '1',
      notes: 'My test meeting',
    },
    {
      title: 'Test5',
      backgroundColor: '#007CBE',
      start: new Date('22/3/2023'),
      end: new Date('22/4/2023'),
      id: '2',
      notes: 'My test meeting',
    },
  ];

  useEffect(() => {
    dispatch(
      fetchWemScheduleEvents({
        currentDate: calendarComponentRef?.current?.getApi().getDate(),
        currentView: currentView,
        theme,
      })
    );
  }, [scheduleChangeNotifications]);

  useEffect(() => {
    const today = new Date();
    const today_yyyymmdd =
      today.getFullYear() +
      '-' +
      (today.getMonth() + 1) +
      '-' +
      today.getDate();
    const currentCalendarDate = calendarComponentRef?.current
      ?.getApi()
      .getDate();
    const currentCalendarDate_yyyymmdd =
      currentCalendarDate &&
      new Date(currentCalendarDate).getFullYear() +
        '-' +
        (new Date(currentCalendarDate).getMonth() + 1) +
        '-' +
        new Date(currentCalendarDate).getDate();
    if (today_yyyymmdd === currentCalendarDate_yyyymmdd) {
      setIstodaySelected(true);
    } else {
      setIstodaySelected(false);
    }
  }, [titleDate]);

  useEffect(() => {
    dayjs.locale(locale);
  }, [locale]);

  return (
    <>
      {props?.isfullView ? (
        <Grid container sx={schedulerStyles.schedulerToolBarStyles}>
          <Grid sx={schedulerStyles.todayButtonStyle} item lg={2} xl={1}>
            <ToggleButton
              onClick={() => {
                if (calendarComponentRef.current) {
                  calendarComponentRef?.current.getApi().today();
                  setTitleDate(
                    calendarComponentRef?.current.getApi().getDate()
                  );
                  dispatch(
                    fetchWemScheduleEvents({
                      currentDate: calendarComponentRef?.current
                        .getApi()
                        .getDate(),
                      currentView: currentView,
                      theme,
                    })
                  );
                }
              }}
              value={'today'}
              selected={isTodaySelected}
            >
              {translate('today')}
            </ToggleButton>
          </Grid>
          <Grid sx={schedulerStyles.navigatorStyles} item md={12} lg={8} xl={6}>
            <CcfButton
              onClick={() => {
                if (calendarComponentRef.current) {
                  calendarComponentRef?.current.getApi().prev();
                  setTitleDate(
                    calendarComponentRef?.current.getApi().getDate()
                  );
                  dispatch(
                    fetchWemScheduleEvents({
                      currentDate: calendarComponentRef?.current
                        .getApi()
                        .getDate(),
                      currentView: currentView,
                      theme,
                    })
                  );
                }
              }}
              sx={schedulerStyles.prevButtonStyle}
            >
              <CcfUpArrowIcon viewBox="-5 2 30 10" />
            </CcfButton>
            <CcfButton className="title">
              {isSmView
                ? dayjs(titleDate).format('dddd | MMM D, YYYY')
                : dayjs(titleDate).format('MMM D, YYYY')}
            </CcfButton>
            {!isSmView && (
              <CcfButton disabled>
                <CcfCalendarIcon viewBox="-6 -7 32 32" />
              </CcfButton>
            )}
            <CcfButton
              onClick={() => {
                if (calendarComponentRef.current) {
                  calendarComponentRef.current.getApi().next();
                  setTitleDate(calendarComponentRef.current.getApi().getDate());
                  dispatch(
                    fetchWemScheduleEvents({
                      currentDate: calendarComponentRef?.current
                        .getApi()
                        .getDate(),
                      currentView: currentView,
                      theme,
                    })
                  );
                }
              }}
              sx={schedulerStyles.nextButtonStyle}
            >
              <CcfUpArrowIcon viewBox="-9 5 30 10" />
            </CcfButton>
          </Grid>
          <Grid item sx={schedulerStyles.viewChangerStyles} lg={3} xl={3}>
            <CcfButton
              sx={{
                backgroundColor:
                  currentView === 'day' ? '#ecf5fa !important' : 'auto',
              }}
              onClick={() => {
                if (calendarComponentRef.current) {
                  calendarComponentRef.current
                    .getApi()
                    .changeView('timeGridDay');
                  setCurrentView('day');
                  dispatch(
                    fetchWemScheduleEvents({
                      currentDate: calendarComponentRef?.current
                        .getApi()
                        .getDate(),
                      currentView: 'day',
                      theme,
                    })
                  );
                }
              }}
            >
              {translate('day')}
            </CcfButton>
            <CcfButton
              sx={{
                backgroundColor:
                  currentView === 'week' ? '#ecf5fa !important' : 'auto',
              }}
              onClick={() => {
                if (calendarComponentRef.current) {
                  calendarComponentRef.current
                    .getApi()
                    .changeView('timeGridWeek');
                  setCurrentView('week');
                  dispatch(
                    fetchWemScheduleEvents({
                      currentDate: calendarComponentRef?.current
                        .getApi()
                        .getDate(),
                      currentView: 'week',
                      theme,
                    })
                  );
                }
              }}
            >
              {translate('week')}
            </CcfButton>
          </Grid>
        </Grid>
      ) : props?.isWemView ? (
        <Grid container sx={schedulerStyles.schedulerToolBarStylesWem}>
          <Grid
            sx={schedulerStyles.navigatorStylesWem}
            item
            md={12}
            lg={8}
            xl={6}
          >
            <CcfButton
              onClick={() => {
                if (calendarComponentRef.current) {
                  calendarComponentRef?.current.getApi().prev();
                  setTitleDate(
                    calendarComponentRef?.current.getApi().getDate()
                  );
                  dispatch(
                    fetchWemScheduleEvents({
                      currentDate: calendarComponentRef?.current
                        .getApi()
                        .getDate(),
                      currentView: currentView,
                      theme,
                    })
                  );
                }
              }}
              sx={schedulerStyles.prevButtonStyle}
            >
              <CcfUpArrowIcon viewBox="-5 2 30 10" />
            </CcfButton>
            <CcfButton className="title">
              {dayjs(titleDate).format('MMM D, YYYY')}
            </CcfButton>
            {!isSmView && (
              <CcfButton disabled>
                <CcfCalendarIcon viewBox="-6 -7 32 32" />
              </CcfButton>
            )}
            <CcfButton
              onClick={() => {
                if (calendarComponentRef.current) {
                  calendarComponentRef.current.getApi().next();
                  setTitleDate(calendarComponentRef.current.getApi().getDate());
                  dispatch(
                    fetchWemScheduleEvents({
                      currentDate: calendarComponentRef?.current
                        .getApi()
                        .getDate(),
                      currentView: currentView,
                      theme,
                    })
                  );
                }
              }}
              sx={schedulerStyles.nextButtonStyle}
            >
              <CcfUpArrowIcon viewBox="-9 5 30 10" />
            </CcfButton>
          </Grid>
          <Grid item sx={schedulerStyles.viewChangerStyles} lg={3} xl={3}>
            <CcfButton
              onClick={() => {
                if (calendarComponentRef.current) {
                  calendarComponentRef?.current.getApi().today();
                  setTitleDate(
                    calendarComponentRef?.current.getApi().getDate()
                  );
                  dispatch(
                    fetchWemScheduleEvents({
                      currentDate: calendarComponentRef?.current
                        .getApi()
                        .getDate(),
                      currentView: currentView,
                      theme,
                    })
                  );
                }
              }}
              value={'today'}
              // selected={isTodaySelected}
            >
              {translate('today')}
            </CcfButton>
            <Grid
              item
              sx={schedulerStyles.viewChangerStyles}
              style={{ minWidth: '45%' }}
            >
              <CcfButton
                sx={{
                  backgroundColor:
                    currentView === 'day' ? '#ecf5fa !important' : 'auto',
                  borderBottomRightRadius: '0px !important',
                  borderTopRightRadius: '0px !important',
                }}
                onClick={() => {
                  if (calendarComponentRef.current) {
                    calendarComponentRef.current
                      .getApi()
                      .changeView('timeGridDay');
                    setCurrentView('day');
                    dispatch(
                      fetchWemScheduleEvents({
                        currentDate: calendarComponentRef?.current
                          .getApi()
                          .getDate(),
                        currentView: 'day',
                        theme,
                      })
                    );
                  }
                }}
              >
                {translate('day')}
              </CcfButton>
              <CcfButton
                sx={{
                  backgroundColor:
                    currentView === 'week' ? '#ecf5fa !important' : 'auto',
                }}
                onClick={() => {
                  if (calendarComponentRef.current) {
                    calendarComponentRef.current
                      .getApi()
                      .changeView('timeGridWeek');
                    setCurrentView('week');
                    dispatch(
                      fetchWemScheduleEvents({
                        currentDate: calendarComponentRef?.current
                          .getApi()
                          .getDate(),
                        currentView: 'week',
                        theme,
                      })
                    );
                  }
                }}
              >
                {translate('week')}
              </CcfButton>
            </Grid>
            <CcfButton sx={schedulerStyles.btn}>
              <CcfTypography
                sx={schedulerStyles.btnText}
                translationKey={'addActivity'}
              ></CcfTypography>
            </CcfButton>
            <CcfButton sx={schedulerStyles.overflowBtn}>
              <CcfOverflowIcon />
            </CcfButton>
          </Grid>
        </Grid>
      ) : (
        <Grid container sx={schedulerStyles.schedulerToolBarStyles}>
          <Grid sx={schedulerStyles.navigatorStylesforAppSpace} item>
            <CcfButton
              onClick={() => {
                if (calendarComponentRef.current) {
                  calendarComponentRef?.current.getApi().prev();
                  setTitleDate(
                    calendarComponentRef?.current.getApi().getDate()
                  );
                  dispatch(
                    fetchWemScheduleEvents({
                      currentDate: calendarComponentRef?.current
                        .getApi()
                        .getDate(),
                      currentView: currentView,
                      theme,
                    })
                  );
                }
              }}
              sx={schedulerStyles.prevButtonStyle}
            >
              <CcfUpArrowIcon viewBox="-5 2 30 10" />
            </CcfButton>
            <CcfButton className="dateTitle">
              {dayjs(titleDate).format('dddd | MMM D, YYYY')}
            </CcfButton>
            <CcfButton
              onClick={() => {
                if (calendarComponentRef.current) {
                  calendarComponentRef.current.getApi().next();
                  setTitleDate(calendarComponentRef.current.getApi().getDate());
                  dispatch(
                    fetchWemScheduleEvents({
                      currentDate: calendarComponentRef?.current
                        .getApi()
                        .getDate(),
                      currentView: currentView,
                      theme,
                    })
                  );
                }
              }}
              sx={schedulerStyles.nextButtonStyle}
            >
              <CcfUpArrowIcon viewBox="-9 5 30 10" />
            </CcfButton>
          </Grid>
          {!disableAddEvent && (
            <Grid
              item
              sx={schedulerStyles.addEventButton}
              // md={12}
              // lg={4}
              // xl={2}
              ref={popOverRef}
            >
              <CcfAddEventPopover
                paperProps={{
                  style: {
                    width: `${popOverRef?.current?.offsetWidth}px`,
                    minWidth: '150px',
                  },
                }}
              />
            </Grid>
          )}
        </Grid>
      )}
      <Grid sx={schedulerStyles.appScheduler}>
        <CcfScheduler
          events={[...events, ...commitments]}
          ref={calendarComponentRef}
          scrollTime={dayjs().subtract(1, 'hour').format('H:mm:ss')}
          allDaySlot={props?.isWemView ? false : true}
          renderScheduleContent={getCcfAppScheduleContent}
          isWemView={props?.isWemView}
        />
      </Grid>
    </>
  );
};

export default SchedulerLargeView;
